import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import AddIcon from '@/shared-components/icons/components/actions/AddIcon';
import PublicSuccessCheck from '@/shared-components/icons/components/public/PublicSuccessCheck';
import AddArtworkToArtlistLoader from '@/shared-components/loader/special-loaders/AddArtworkToArtlistLoader';
import Text from '@/shared-components/text/components/Text';
import { getArtworkArtistDisplayName } from '@/utils/artworkArtists';

import './styles/Row.css';

export default function Row({ artwork, isArtworkInList, setSelectedArtworks, canIselectMore }) {
  const t = useTranslations('common.profile.pages.artlist');
  const [loading, setLoading] = useState(false);
  const artistName = getArtworkArtistDisplayName(artwork);

  async function addArtworkToList() {
    setLoading(true);
    setSelectedArtworks((artworks) => [...artworks, artwork]);
    setLoading(false);
  }

  function removeArtworkFromList() {
    setLoading(true);
    setSelectedArtworks(prev => {
      return prev.filter(a => a._id !== artwork._id);
    } );
    setLoading(false);
  }

  return (
    <div className={`artlist-add-artworks__artwork-result element-non-selectable ${isArtworkInList ? "active" : ""}`}>
      <div className="artlist-add-artworks__artwork-info">
        <ArtworkImage 
          image={artwork.artwork_media.artwork_main_picture.image_id} 
          imageClassName="artlist-add-artwork__artwork-image" 
          imageTemplateClassName="artlist-add-artwork__artwork-image"
        />

        <div className="artlist-add-artworks__artwork-text-container">
          <Text
            className="artlist-add-artworks__artwork-title"
            paragraph>
            {artwork.artwork_about.artwork_title}
          </Text>

          <Text className="artlist-add-artworks__artwork-artist" paragraph>
            {t('labels.by')} {artistName}
          </Text>
        </div>
      </div>
      {loading ? (
        <div className="artlist-add-artworks__spinner-wrapper">
          <div className="loader-position-wrapper">
            <AddArtworkToArtlistLoader />
          </div>
        </div>
      ) : isArtworkInList ? (
        <PublicSuccessCheck
          className="artlist-add-artworks__artwork-added"
          onClick={removeArtworkFromList}
        />
      ) : canIselectMore ? (
        <AddIcon 
          className="artlist-add-artworks__artwork-add"
          onClick={addArtworkToList}
        />
      ) : null}
    </div>
  );
}
